import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const ProgressSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ProgressDot = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ tone }) => (tone === 'complete' ? '#22c55e' : '#F59E0B')};
`

export const ProgressLabel = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: #111827;
  flex: 1;
`

export const InProgressPill = styled.span`
  padding: 5px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  color: #1e40af;
  background: #dbeafe;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  height: 16px;
  border-radius: 999px;
  background: #d9d9d9;
  margin-bottom: 24px;
`

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: ${({ tone }) => (tone === 'complete' ? '#22c55e' : '#F59E0B')};
  width: ${({ percent }) => percent}%;
  transition: width 0.3s ease;
`

export const ProgressTarget = styled.div`
  position: absolute;
  top: 0px;
  left: ${({ percent }) => percent}%;
  width: 3px;
  height: 16px;
  background: #1f2937;
`

export const ProgressTargetLabel = styled.div`
  position: absolute;
  top: 20px;
  left: ${({ percent }) => percent - 5}%;
  font-size: 16px;
  color: #444444;
`

export const SubBarsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`

export const SubBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const SubBarLabel = styled.div`
  width: 160px;
  font-size: 16px;
  font-weight: 500;
  color: #4b5563;
  flex-shrink: 0;
`
